import personType from '../type/personType';

export default () => `
	loggedInUser {
		${personType()}
	}
`;
